import { render, staticRenderFns } from "./KQuestionCheckboxGroupView.vue?vue&type=template&id=6a626086&"
import script from "./KQuestionCheckboxGroupView.vue?vue&type=script&lang=js&"
export * from "./KQuestionCheckboxGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports